var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DA3A2"
    },
    d: "M115.2,267.2c0,12.8-10.4,24-24,24H72c-12.8,0-24-10.4-24-24v-30.4c0-12.8,10.4-24,24-24h20 c12.8,0,24,10.4,24,24v30.4H115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E8987"
    },
    d: "M115.2,264c0,10.4-10.4,18.4-24,18.4H72c-12.8,0-24-8-24-18.4v-24c0-10.4,10.4-18.4,24-18.4h20 c12.8,0,24,8,24,18.4v24H115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687270"
    },
    d: "M115.2,259.2c0,6.4-10.4,11.2-24,11.2H72c-12.8,0-24-4.8-24-11.2v-14.4c0-6.4,10.4-11.2,24-11.2h20 c12.8,0,24,4.8,24,11.2v14.4H115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#605854"
    },
    d: "M379.2,480c0,12.8-10.4,24-24,24H182.4c-12.8,0-24-10.4-24-24V24c0-12.8,10.4-24,24-24h172.8 c12.8,0,24,10.4,24,24V480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#443932"
    },
    d: "M182.4,0h172.8c12.8,0,24,10.4,24,24v456c0,12.8-10.4,24-24,24H182.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D241F"
    },
    d: "M355.2,0c12.8,0,24,10.4,24,24v456c0,12.8-10.4,24-24,24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7BC3"
    },
    d: "M366.4,49.6c0,7.2-5.6,12.8-12.8,12.8h-176c-7.2,0-12.8-5.6-12.8-12.8l0,0c0-7.2,5.6-12.8,12.8-12.8 h175.2C360.8,36.8,366.4,42.4,366.4,49.6L366.4,49.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA0C6A"
    },
    d: "M366.4,449.6c0,7.2-5.6,12.8-12.8,12.8h-176c-7.2,0-12.8-5.6-12.8-12.8l0,0 c0-7.2,5.6-12.8,12.8-12.8h175.2C360.8,436.8,366.4,442.4,366.4,449.6L366.4,449.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA0C6A"
    },
    d: "M456,404c0,21.6-17.6,49.6-38.4,49.6H114.4C92.8,453.6,76,424.8,76,404V100 c0-21.6,17.6-49.6,38.4-49.6h303.2c21.6,0,38.4,28.8,38.4,49.6V404z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7BC3"
    },
    d: "M456,404c0,21.6-17.6,38.4-38.4,38.4H114.4C92.8,442.4,76,424.8,76,404V100 c0-21.6,17.6-49.6,38.4-49.6h303.2c21.6,0,38.4,28.8,38.4,49.6V404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF3388"
    },
    d: "M456,404c0,21.6-17.6,38.4-38.4,38.4H114.4C92.8,442.4,76,424.8,76,404V100 c0-21.6,17.6-38.4,38.4-38.4h303.2c21.6,0,38.4,17.6,38.4,38.4V404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C61777"
    },
    d: "M114.4,61.6h303.2c21.6,0,38.4,17.6,38.4,38.4v304c0,21.6-17.6,38.4-38.4,38.4H114.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA0C6A"
    },
    d: "M417.6,61.6c21.6,0,38.4,17.6,38.4,38.4v304c0,21.6-17.6,38.4-38.4,38.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#093F63"
    },
    d: "M421.6,376c0,17.6-14.4,32-32,32h-248c-17.6,0-32-14.4-32-32V128c0-17.6,14.4-32,32-32h248 c17.6,0,32,14.4,32,32V376z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M141.6,96h248c17.6,0,32,14.4,32,32v248c0,17.6-14.4,32-32,32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M174.4,301.6c-5.6,0-10.4-0.8-14.4-3.2c-4-2.4-8-4.8-11.2-8.8s-5.6-8-7.2-12.8 c-1.6-4.8-2.4-10.4-2.4-16l0,0c0-5.6,0.8-11.2,2.4-16c1.6-4.8,4-9.6,7.2-12.8c3.2-4,6.4-6.4,11.2-8.8c4-2.4,8.8-3.2,14.4-3.2 c4.8,0,9.6,0.8,14.4,3.2c4,2.4,8,4.8,11.2,8.8s5.6,8,7.2,12.8c1.6,4.8,2.4,10.4,2.4,16l0,0c0,5.6-0.8,11.2-2.4,16 c-1.6,4.8-4,9.6-7.2,12.8c-3.2,4-6.4,6.4-11.2,8.8C184.8,300,180,301.6,174.4,301.6z M175.2,285.6c2.4,0,4.8-0.8,7.2-1.6 c2.4-1.6,4-3.2,5.6-5.6s2.4-4.8,3.2-8S192,264,192,260l0,0c0-4-0.8-7.2-1.6-9.6c-0.8-3.2-2.4-5.6-3.2-8c-1.6-2.4-3.2-4-5.6-5.6 c-2.4-1.6-4.8-1.6-7.2-1.6s-4.8,0.8-7.2,1.6c-2.4,1.6-4,3.2-5.6,4.8c-1.6,2.4-2.4,4.8-3.2,8s-1.6,6.4-1.6,10.4l0,0 c0,4,0,7.2,1.6,10.4c0.8,3.2,1.6,5.6,3.2,8c1.6,2.4,3.2,4,5.6,5.6C169.6,284.8,172,285.6,175.2,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M221.6,286.4l26.4-21.6c2.4-2.4,4.8-4,6.4-5.6s3.2-3.2,4-4.8c0.8-1.6,1.6-3.2,2.4-4 c0.8-1.6,0.8-3.2,0.8-4.8c0-3.2-0.8-5.6-3.2-8c-1.6-1.6-4.8-2.4-8-2.4c-3.2,0-5.6,0.8-8,2.4c-2.4,1.6-4.8,4-8,8l-12-9.6 c1.6-2.4,4-4.8,5.6-7.2s4-4,6.4-4.8c2.4-1.6,4.8-2.4,8-3.2c3.2-0.8,5.6-0.8,9.6-0.8s8,0.8,11.2,1.6s6.4,3.2,8.8,4.8 c2.4,2.4,4,4.8,5.6,8s1.6,6.4,1.6,10.4l0,0c0,3.2-0.8,6.4-1.6,8.8c-0.8,2.4-2.4,4.8-4,7.2c-1.6,2.4-4,4.8-6.4,7.2 c-2.4,2.4-5.6,4.8-8.8,7.2l-12.8,9.6H280V300h-58.4L221.6,286.4L221.6,286.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M293.6,260.8L293.6,260.8c0-21.6,12.8-40.8,32.8-40.8s32.8,19.2,32.8,40.8l0,0 c0,21.6-12.8,40.8-32.8,40.8C306.4,301.6,293.6,282.4,293.6,260.8z M352.8,260.8L352.8,260.8c0-18.4-10.4-36-26.4-36 S300,241.6,300,260l0,0c0,18.4,10.4,35.2,26.4,35.2C342.4,296,352.8,279.2,352.8,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M385.6,226.4l-12.8,4c-0.8,0-0.8,0-1.6,0c-1.6,0-2.4-0.8-2.4-2.4c0-1.6,0.8-2.4,2.4-2.4l13.6-4.8 c1.6-0.8,2.4-0.8,4-0.8l0,0c1.6,0,3.2,1.6,3.2,3.2v74.4c0,1.6-1.6,3.2-3.2,3.2s-3.2-1.6-3.2-3.2V226.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFD"
    },
    d: "M174.4,292.8c-5.6,0-10.4-0.8-14.4-3.2c-4-2.4-8-4.8-11.2-8.8s-5.6-8-7.2-12.8 c-1.6-4.8-2.4-10.4-2.4-16l0,0c0-5.6,0.8-11.2,2.4-16c1.6-4.8,4-9.6,7.2-12.8c3.2-4,6.4-6.4,11.2-8.8c4-2.4,8.8-3.2,14.4-3.2 c4.8,0,9.6,0.8,14.4,3.2c4,2.4,8,4.8,11.2,8.8s5.6,8,7.2,12.8c1.6,4.8,2.4,10.4,2.4,16l0,0c0,5.6-0.8,11.2-2.4,16 c-1.6,4.8-4,9.6-7.2,12.8c-3.2,4-6.4,6.4-11.2,8.8C184.8,292,180,292.8,174.4,292.8z M175.2,276.8c2.4,0,4.8-0.8,7.2-1.6 c2.4-1.6,4-3.2,5.6-5.6s2.4-4.8,3.2-8s0.8-6.4,0.8-10.4l0,0c0-4-0.8-7.2-1.6-9.6c-0.8-3.2-2.4-5.6-3.2-8c-1.6-2.4-3.2-4-5.6-5.6 c-2.4-1.6-4.8-1.6-7.2-1.6s-4.8,0.8-7.2,1.6c-2.4,1.6-4,3.2-5.6,4.8c-1.6,2.4-2.4,4.8-3.2,8s-1.6,6.4-1.6,10.4l0,0 c0,4,0,7.2,1.6,10.4c0.8,3.2,1.6,5.6,3.2,8c1.6,2.4,3.2,4,5.6,5.6S172,276.8,175.2,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFD"
    },
    d: "M221.6,277.6L248,256c2.4-2.4,4.8-4,6.4-5.6s3.2-3.2,4-4.8s1.6-3.2,2.4-4c0.8-1.6,0.8-3.2,0.8-4.8 c0-3.2-0.8-5.6-3.2-8c-1.6-1.6-4.8-2.4-8-2.4c-3.2,0-5.6,0.8-8,2.4c-2.4,1.6-4.8,4-8,8l-12-8.8c1.6-2.4,4-4.8,5.6-7.2s4-4,6.4-4.8 c2.4-1.6,4.8-2.4,8-3.2c2.4-0.8,5.6-0.8,9.6-0.8s8,0.8,11.2,1.6s6.4,3.2,8.8,4.8c2.4,2.4,4,4.8,5.6,8s1.6,6.4,1.6,10.4l0,0 c0,3.2-0.8,6.4-1.6,8.8c-0.8,2.4-2.4,4.8-4,7.2c-1.6,2.4-4,4.8-6.4,7.2c-2.4,2.4-5.6,4.8-8.8,7.2l-12.8,9.6H280V292h-58.4 L221.6,277.6L221.6,277.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACBCBB"
    },
    d: "M293.6,252L293.6,252c0-21.6,12.8-40.8,32.8-40.8s32.8,19.2,32.8,40.8l0,0 c0,21.6-12.8,40.8-32.8,40.8S293.6,273.6,293.6,252z M352.8,252L352.8,252c0-18.4-10.4-36-26.4-36S300,232.8,300,251.2l0,0 c0,18.4,10.4,35.2,26.4,35.2C342.4,287.2,352.8,270.4,352.8,252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACBCBB"
    },
    d: "M385.6,217.6l-12.8,4c-0.8,0-0.8,0-1.6,0c-1.6,0-2.4-0.8-2.4-2.4c0-1.6,0.8-2.4,2.4-2.4l13.6-4.8 c1.6-0.8,2.4-0.8,4-0.8l0,0c1.6,0,3.2,1.6,3.2,3.2v74.4c0,1.6-1.6,3.2-3.2,3.2s-3.2-1.6-3.2-3.2V217.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 236,
    cy: 80.8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 265.6,
    cy: 80.8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 295.2,
    cy: 80.8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 236,
    cy: 423.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 265.6,
    cy: 423.2,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF3388"
    },
    cx: 295.2,
    cy: 423.2,
    r: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7BC3"
    },
    d: "M104.8,73.6c3.2,2.4,1.6,11.2-4,18.4c-5.6,7.2-12.8,11.2-16.8,8c-3.2-2.4-1.6-11.2,4-18.4 C93.6,75.2,101.6,71.2,104.8,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7BC3"
    },
    d: "M88.8,387.2c0,2.4-1.6,4-4,4l0,0c-2.4,0-4-1.6-4-4v-272c0-2.4,1.6-4,4-4l0,0c2.4,0,4,1.6,4,4V387.2z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.ffc6ea8ebdd373b66a6293632ac2d4df.svg";
export { ForwardRef as ReactComponent };